// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.recording-consent-screen-content[data-v-de518222] {\n  color: #000000;\n}\n", ""]);
// Exports
module.exports = exports;
